/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const ExpandSolidV6 = (props) => (
  <Icon {...props} name="Expand Solid V6">
    <path d="M5 1H2a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0V3h2a1 1 0 1 0 0-2zm9 0h-3a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0V2a1 1 0 0 0-1-1zM5 13H3v-2a1 1 0 1 0-2 0v3a1 1 0 0 0 1 1h3a1 1 0 1 0 0-2zm9-3a1 1 0 0 0-1 1v2h-2a1 1 0 1 0 0 2h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z" />
  </Icon>
);

export default ExpandSolidV6;
